import React, { useEffect, useRef, useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Mapa from "../../../images/modulo14/mapapintar.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faEraser } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import { ReactSketchCanvas } from "react-sketch-canvas";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad2Actividad2.mp3";

const styles = {
  height: "880px",
  background: `url(${Mapa})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
};

const Actividad3 = () => {
  const [color, setColor] = useState("red");
  const [eraseMode, setEraseMode] = useState(false);
  const [penMode, setPenMode] = useState(true);
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[1];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[2].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[2].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[0].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[0].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  const canvasEl = useRef(null);
  const activateEraser = () => {
    setEraseMode(!eraseMode);
    setPenMode(eraseMode);
  };
  const activatePen = () => {
    setPenMode(!penMode);
    setEraseMode(penMode);
  };
  useEffect(() => {
    if (eraseMode) {
      canvasEl.current.eraseMode(true);
    } else {
      canvasEl.current.eraseMode(false);
    }
  }, [eraseMode]);
  const changeColor = (color) => {
    setColor(color);
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-md-4">
          <ul>
            <li>
              En el mapa que aparece a continuación, pinta de distintos colores
              los territorios donde crees que se hablan las siguientes
              variedades de castellano:
            </li>
          </ul>
          <div className="px-4">
            <p>- Castellano andino (rojo)</p>
            <p>- Castellano amazónico (verde) </p>
            <p>- Castellano del norte (amarillo)</p>
            <p>- Castellano limeño (azul)</p>
          </div>
        </div>
        <div className="col-md-8 col-12">
          <ReactSketchCanvas
            ref={canvasEl}
            style={styles}
            width="600"
            height="100%"
            strokeWidth={4}
            strokeColor={color}
          />
        </div>
        <div className="d-flex mt-1 justify-content-end w-100">
          <button
            onClick={activateEraser}
            className={`btn btn-green me-1 ${
              eraseMode ? "active" : "inactive"
            }`}
          >
            Borrador <FontAwesomeIcon icon={faEraser} />
          </button>
          <button
            onClick={activatePen}
            className={`btn btn-green me-1 ${penMode ? "active" : "inactive"}`}
          >
            Lapiz <FontAwesomeIcon icon={faPen} />
          </button>
          <button
            onClick={() => changeColor("blue")}
            className={`btn btn-primary me-1 ${
              penMode ? "active" : "inactive"
            }`}
          >
            Azul
          </button>
          <button
            onClick={() => changeColor("yellow")}
            className={`btn btn-warning me-1 ${
              penMode ? "active" : "inactive"
            }`}
          >
            Amarillo
          </button>
          <button
            onClick={() => changeColor("red")}
            className={`btn btn-red me-1 ${penMode ? "active" : "inactive"}`}
          >
            Rojo
          </button>
          <button
            onClick={() => changeColor("green")}
            className={`btn btn-success me-1 ${
              penMode ? "active" : "inactive"
            }`}
          >
            Verde
          </button>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: En el mapa que aparece a continuación,
            pinta de distintos colores los territorios donde crees que se hablan
            las siguientes variedades de castellano: - Castellano andino (rojo)
            - Castellano amazónico (verde) - Castellano del norte (amarillo) -
            Castellano limeño (azul)
          </li>
          <li>
            Explique que en la imagen tienen un mapa del Perú
            dividido en departamentos. Ayude al niño o a la niña a ubicar cuáles
            son los departamentos que podrían estar bajo la denominación de
            “andino”, “amazónico”, “del norte”, “limeño”. Por ejemplo:
            <ul>
              <li>
                <i>
                  “¿Cuáles son los departamentos en los que se habla castellano
                  andino? (Posible respuesta: Principalmente en los
                  departamentos de la sierra. Entonces se deberá colorear de
                  rojo los siguientes departamentos: Cajamarca, Huánuco, Pasco,
                  Junín, Ayacucho, Apurímac, Huancavelica, Cuzco, Puno).
                </i>
              </li>
              <li>
                <i>
                  ¿Cuáles son los departamentos en los que se habla castellano
                  amazónico? (Posible respuesta: Principalmente en los
                  departamentos de la selva, es decir, Amazonas, Loreto, San
                  Martín, Ucayali, Madre de Dios).
                </i>
              </li>
              <li>
                <i>
                  ¿Cuáles son los departamentos en los que se habla castellano
                  del norte? (Posible respuesta: Principalmente en los
                  departamentos de la costa norte: Tumbes, Piura, Lambayeque,
                  Cajamarca, La Libertad).
                </i>
              </li>
              <li>
                <i>
                  ¿Cuáles son los departamentos en los que se habla castellano
                  limeño? (Posible respuesta: Lima)”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Es importante resaltar que las lenguas y sus variedades no tienen
            límites territoriales demarcados. Por ello, en un departamento
            podemos encontrar diversas variedades de castellano. Además,
            recordemos que las lenguas se mueven con sus hablantes. Por eso, es
            posible, por ejemplo, encontrar muchos hablantes de castellano
            andino en Lima.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
